import React from "react";
import ResponsiveImage from "../responsive-image/ResponsiveImage";
import { useTranslation } from "react-i18next"; // Import useTranslation hook for translations
import "./Footer.css"; // Import the CSS file

// Import social media icons
import YouTubeIcon from "../../icons/YouTube.png";
import InstagramIcon from "../../icons/Instagram.png";
import FacebookIcon from "../../icons/Facebook.png";

import enTranslations from "./en.json"; // Import English translations
import deTranslations from "./de.json"; // Import German translations

const Footer = () => {
  const { t, i18n } = useTranslation(); // Translation hook

  // Add translation resources for this component
  i18n.addResourceBundle("en", "footer", enTranslations, true, true);
  i18n.addResourceBundle("de", "footer", deTranslations, true, true);

  return (
    <footer className="footer" role="contentinfo">
      <div className="left-part">
        <div className="text-buttons">
          <a
            href={i18n.language === "en" ? "/en/contact" : "/contact"}
            className="footer-link focus-highlight"
            tabIndex={0}
            aria-label={t("footer:contact_aria_label")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                window.location.href =
                  i18n.language === "en" ? "/en/contact" : "/contact";
              }
            }}
          >
            {t("footer:contact")}
          </a>
          <a
            href={
              i18n.language === "en" ? "/en/privacy_notice" : "/privacy_notice"
            }
            className="footer-link focus-highlight"
            tabIndex={0}
            aria-label={t("footer:privacy_policy_aria_label")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                window.location.href =
                  i18n.language === "en"
                    ? "/en/privacy_notice"
                    : "/privacy_notice";
              }
            }}
          >
            {t("footer:privacy_policy")}
          </a>
          <a
            href={i18n.language === "en" ? "/en/imprint" : "/imprint"}
            className="footer-link focus-highlight"
            tabIndex={0}
            aria-label={t("footer:imprint_aria_label")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                window.location.href =
                  i18n.language === "en" ? "/en/imprint" : "/imprint";
              }
            }}
          >
            {t("footer:imprint")}
          </a>
          <a
            href={i18n.language === "en" ? "/en/disclaimer" : "/disclaimer"}
            className="footer-link focus-highlight"
            tabIndex={0}
            aria-label={t("footer:disclaimer_aria_label")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                window.location.href =
                  i18n.language === "en" ? "/en/disclaimer" : "/disclaimer";
              }
            }}
          >
            {t("footer:disclaimer")}
          </a>
        </div>
      </div>
      <div className="right-part">
        <div
          className="social-icons"
          role="group"
          aria-label={t("footer:social_media_group_label")}
        >
          <a
            href="https://www.youtube.com/@Jacobi58"
            className="social-icon focus-highlight"
            target="_blank"
            rel="noopener noreferrer"
            tabIndex={0}
            aria-label={t("footer:youtube_aria_label")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                window.open(
                  "https://www.youtube.com/@Jacobi58",
                  "_blank",
                  "noopener noreferrer"
                );
              }
            }}
          >
            <ResponsiveImage src={YouTubeIcon} alt="" sizes="40px" className="social-icon-img" />
          </a>
          <a
            href="https://www.instagram.com/jacobi_geigenbau/"
            className="social-icon focus-highlight"
            target="_blank"
            rel="noopener noreferrer"
            tabIndex={0}
            aria-label={t("footer:instagram_aria_label")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                window.open(
                  "https://www.instagram.com/jacobi_geigenbau/",
                  "_blank",
                  "noopener noreferrer"
                );
              }
            }}
          >
            <ResponsiveImage src={InstagramIcon} alt="" sizes="40px" className="social-icon-img" />
          </a>
          <a
            href="https://www.facebook.com/GeigenbauJacobi/?locale=de_DE"
            className="social-icon focus-highlight"
            target="_blank"
            rel="noopener noreferrer"
            tabIndex={0}
            aria-label={t("footer:facebook_aria_label")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                window.open(
                  "https://www.facebook.com/GeigenbauJacobi/?locale=de_DE",
                  "_blank",
                  "noopener noreferrer"
                );
              }
            }}
          >
            <ResponsiveImage src={FacebookIcon} alt="" sizes="40px" className="social-icon-img" />
          </a>
        </div>
        <div className="copyright">{t("footer:copyright")}</div>
      </div>
    </footer>
  );
};

export default Footer;
